/*
  Prefetch Service
  madeby Sun
*/

let prefetchService = {

  filterQuery(query) {
    // Check token
    if (query && query.token) {
      return { token: query.token }
    }
    return false
  },
}

export default prefetchService
